import React from 'react';
import ContentLoader from 'react-content-loader';
import { Carousel } from 'antd-mobile';
import styles from './index.less';
import { gioClick } from '@/utils/gioApi';
// 骨架屏
const MyLoader = (props) => (
  <ContentLoader
    rtl
    height={props.height || 750}
    width={750}
    speed={2}
    primaryColor="#f3f3f3"
    secondaryColor="#ecebeb"
    {...props}
  >
    <rect x="-1" y="-8" rx="5" ry="5" width="780" height="772" />
  </ContentLoader>
);

interface IBannerProps {
  imgsList: Array<any>;
  autoPlay?: boolean;
  autoplayInterval?: number;
  clickImg?: (x: number) => void;
  dots?: boolean;
  height?: number;
  curIdx?: number;
  changeIndex?: (x: number) => void;
}

const Banner = function(props: IBannerProps): JSX.Element {
  const { imgsList = [], dots = false, autoPlay, autoplayInterval = 3000, height = 280 } = props;

  /*** 曝光的代码 */
  const scrollGio = (index) => {
    // 计算页面置顶元素高度
    let minusTop = window.innerWidth * 0.228;
    let minusLeft = window.innerWidth * 0.04;
    let $dom = document.getElementById('homeBanner');
    if ($dom) {
      const offset = $dom.getBoundingClientRect();
      const offsetTop = offset.top;
      const offsetBottom = offset.bottom;
      const offsetLeft = offset.left;
      const offsetRight = offset.right;
      if (offsetTop <= window.innerHeight && offsetBottom >= minusTop && offsetLeft < window.innerWidth && offsetRight > minusLeft) {
        gioClick('电影-频道首页', {
          pagename: '电影首页',
          modulename: '轮播',
          elementname: '轮播',
          floorNum: 2,
          HPbanenrNum: index + 1,
          JumpAddress: imgsList?.[index]?.href,
          channle: '电影'
        }, 'DF_exposureEvent');
      }
    }
  };
  /*** 曝光的代码 */

  return (
    <div className={`${styles.banner}`} style={{ height: `${height}px` }} id="homeBanner">
      <Carousel
        autoplay={autoPlay}
        autoplayInterval={autoplayInterval}
        infinite
        slideWidth={1}
        dots={dots}
        dotStyle={{
          width: '8px',
          height: '8px',
          background: '#FFF',
          opacity: '0.5',
          borderRadius: '50%'
        }}
        dotActiveStyle={{
          width: '16px',
          height: '8px',
          background: '#FFF',
          opacity: '1',
          borderRadius: '4px'
        }}
        selectedIndex={props.curIdx}
        afterChange={(index) => {
          // setCurIdx(index)
          props.changeIndex && props.changeIndex(index);
        }}
        beforeChange={(index) => {
          scrollGio(index);
        }}
        className="myscroll"
        swipeSpeed={40}
      >
        {imgsList &&
          imgsList.length > 0 &&
          imgsList.map((item, index) => (
            <div key={index}>
              {item.imageUrl ? (
                <img
                  onClick={() => {
                    gioClick('电影-频道首页', { pagename: '电影首页', channle: '电影', modulename: '轮播', elementname: '轮播', floorNum: 2, HPbanenrNum: item?.order, JumpAddress: item?.href});
                    props.clickImg && props.clickImg(index);
                  }}
                  className={styles.proImg}
                  style={{ height: `${height}px` }}
                  src={item.imageUrl}
                  alt={index + ''}
                />
              ) : (
                <MyLoader height={height * 2} />
              )}
            </div>
          ))}
      </Carousel>
    </div>
  );
};

export default Banner;
